(function () {
  function init(root) {
    if (root.dataset.torvaReady) return;
    root.dataset.torvaReady = 'true';
    const data = JSON.parse(root.querySelector('[data-torva-gallery-data]').textContent);
    const managed = root.querySelector('[data-torva-managed]');
    const original = root.querySelector('[data-torva-original]');
    const image = root.querySelector('[data-torva-image]');
    const zoomImage = root.querySelector('[data-torva-zoom-image]');
    const thumbs = root.querySelector('[data-torva-thumbs]');
    const dialog = root.querySelector('[data-torva-dialog]');
    let images = [];
    let index = 0;
    let sku = '';

    function select(position) {
      index = (position + images.length) % images.length;
      image.src = images[index];
      image.alt = sku + ' product image ' + (index + 1) + ' of ' + images.length;
      zoomImage.src = image.src;
      zoomImage.alt = image.alt;
      thumbs.querySelectorAll('button').forEach((button, i) => {
        button.setAttribute('aria-current', String(i === index));
      });
    }

    function show(variant) {
      const entry = data.variants[String(variant.id)] || data.legacy;
      if (!Array.isArray(entry) || !entry.length) {
        managed.hidden = true;
        original.hidden = false;
        root.classList.remove('torva-gallery--managed');
        window.dispatchEvent(new Event('resize'));
        return;
      }
      images = entry;
      sku = variant.sku || '';
      thumbs.replaceChildren();
      images.forEach((src, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Show product image ' + (i + 1));
        const thumb = document.createElement('img');
        thumb.src = src;
        thumb.alt = '';
        thumb.loading = 'lazy';
        button.appendChild(thumb);
        button.addEventListener('click', () => select(i));
        thumbs.appendChild(button);
      });
      select(0);
      original.hidden = true;
      managed.hidden = false;
      root.classList.add('torva-gallery--managed');
      if (dialog.open) dialog.close();
    }

    root.querySelector('[data-torva-prev]').addEventListener('click', () => select(index - 1));
    root.querySelector('[data-torva-next]').addEventListener('click', () => select(index + 1));
    root.querySelector('[data-torva-open]').addEventListener('click', () => dialog.showModal());
    root.querySelector('[data-torva-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    const product = root.closest('[data-js-product-container]');
    const productData = JSON.parse(product.querySelector('[data-js-product-json]').textContent);
    const initial = productData.variants.find((variant) => String(variant.id) === root.dataset.initialVariant);
    if (initial) show(initial);

    const eventName = 'pdp:section-' + root.dataset.sectionId + ':change-variant';
    function listen(attempts) {
      if (window.themeCore && window.themeCore.EventBus) {
        window.themeCore.EventBus.listen(eventName, ({ variant }) => show(variant));
      } else if (attempts < 40) {
        window.setTimeout(() => listen(attempts + 1), 100);
      }
    }
    listen(0);
  }

  function start() {
    document.querySelectorAll('[data-torva-gallery]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
